module.exports = __webpack_public_path__ + "04_long_gray.d7b80ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_long_gray.png
// module id = I1AJ
// module chunks = 0